import { render, staticRenderFns } from "./KanbanFilter.vue?vue&type=template&id=aed9eeb4&scoped=true"
import script from "./KanbanFilter.vue?vue&type=script&lang=js"
export * from "./KanbanFilter.vue?vue&type=script&lang=js"
import style0 from "./KanbanFilter.vue?vue&type=style&index=0&id=aed9eeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed9eeb4",
  null
  
)

export default component.exports